import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationDataService } from 'app/core/authentication';
import { UrlService } from 'app/core/http/url.service';
import { WrappedString } from 'app/core/kh-utils/wrapped-string';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExternalUrlService {
  public constructor(private readonly httpClient: HttpClient,
                     private readonly urlService: UrlService,
                     private readonly authenticationDataService: AuthenticationDataService) { }

  public getExternalUrlObs(customUrl: string, localeId?: string): Observable<WrappedString> {
    if (!localeId) {
      localeId = this.authenticationDataService.getUserLocale();
    }

    const url = this.urlService.buildServerApiUrl('ExternalUrl', localeId, customUrl);

    return this.httpClient.get<WrappedString>(url);
  }
}
